/** Which period the whole page answers for. */

import {
  Button,
  Caption1,
  Input,
  makeStyles,
  tokens,
} from '@fluentui/react-components'
import { Chip, FilterBar } from '../platform'
import { PRESETS, type OverviewRange } from './overviewRange'

const useStyles = makeStyles({
  group: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    flexWrap: 'wrap',
    maxWidth: '100%',
    minWidth: 0,
  },
  chips: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
    flexWrap: 'wrap',
  },
  refused: {
    color: tokens.colorPaletteRedForeground1,
  },
})

export default function RangePicker({
  range,
  onChange,
  refused,
  onBack,
}: {
  range: OverviewRange
  onChange: (range: OverviewRange) => void
  refused: string | null
  /** Present after a zoom from a chart: return to the range before it. */
  onBack?: () => void
}) {
  const styles = useStyles()
  return (
    <FilterBar
      search={
        <div className={styles.group}>
          <div className={styles.chips}>
            {onBack ? (
              <Button size="small" appearance="subtle" onClick={onBack}>
                Back to the previous range
              </Button>
            ) : null}
            {PRESETS.map((preset) => (
              <Chip
                key={preset.key}
                selected={range.preset === preset.key}
                onClick={() => onChange({ ...range, preset: preset.key })}
              >
                {preset.label}
              </Chip>
            ))}
            <Chip
              selected={range.preset === 'custom'}
              onClick={() => onChange({ ...range, preset: 'custom' })}
            >
              A period
            </Chip>
          </div>
          {range.preset === 'custom' ? (
            <div className={styles.chips}>
              <Input
                type="datetime-local"
                value={range.from}
                onChange={(_, data) => onChange({ ...range, from: data.value })}
                aria-label="Range start"
              />
              <Input
                type="datetime-local"
                value={range.to}
                onChange={(_, data) => onChange({ ...range, to: data.value })}
                aria-label="Range end"
              />
            </div>
          ) : null}
          {/* Said before the request rather than after the refusal. A range the
              service will refuse is one the page already knows about, and
              making the reader wait for a 400 to find out is a worse way to
              tell them. */}
          {refused ? <Caption1 className={styles.refused}>{refused}</Caption1> : null}
        </div>
      }
    />
  )
}
